import { createSlice } from "@reduxjs/toolkit";

export interface PaymentState {
  method: string;
  methodId: number;
  details: {
    amount?: number;
    mobileMoneyNumber?: string;
  } | null;
  loading: boolean;
  amountPaid: number;
  balanceDue: number;
  processed: boolean;
  error: string | null;
}

const initialState: PaymentState = {
  method: "",
  methodId: 0,
  details: null,
  loading: false,
  amountPaid: 0,
  balanceDue: 0,
  processed: false,
  error: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    clearPayment: (state) => {
      return initialState;
    },
    setPaymentDetails: (state, action) => {
      state.method = action.payload.method;
      state.methodId = action.payload.methodId;
      state.details = action.payload.details;
      state.amountPaid = action.payload.amountPaid;
      state.loading = false;
      state.processed = true;
      state.error = null;
    },
  },
});

export const { clearPayment, setPaymentDetails } = paymentSlice.actions;

export default paymentSlice.reducer;
